import React from "react";
import styled from "styled-components";
import { HeaderContainer, TabLink, TabLinks } from ".";
import OperationalSitesActive from "../../images/icons/OperationalSitesActive.svg";
import OperationalSitesInActive from "../../images/icons/OperationalSitesInActive.svg";
import PortfolioTab from "../PortfolioTab";
import ShareLinkWithUser from "../modal/ShareLinkWithUser";
import { ShareAttributes } from "./SiteViewHeader";

const FunderPortfolioHeader: React.FC<{
  currentUrl: string;
  spvsCount: number;
  rootPath: string;
  orgType: string;
  shareAttributes: ShareAttributes;
}> = ({ currentUrl, spvsCount, rootPath, orgType, shareAttributes }) => {
  const dashboardUrl = `${rootPath}dashboard`;

  return (
    <HeaderContainer>
      <FunderTabLinks
        currentUrl={currentUrl}
        dashboardUrl={dashboardUrl}
        spvsCount={spvsCount}
        shareAttributes={shareAttributes}
        orgType={orgType}
      />
    </HeaderContainer>
  );
};

export default FunderPortfolioHeader;

const FunderTabLinks: React.FC<{
  currentUrl: string;
  dashboardUrl: string;
  spvsCount: number;
  shareAttributes: ShareAttributes;
  orgType: string;
}> = ({ currentUrl, dashboardUrl, spvsCount, shareAttributes, orgType }) => {
  return (
    <TabLinks>
      <TabLink to={dashboardUrl} $active={currentUrl === dashboardUrl}>
        <PortfolioTab
          active={currentUrl === dashboardUrl}
          tabName={"SPVs"}
          icon={
            currentUrl === dashboardUrl
              ? OperationalSitesActive
              : OperationalSitesInActive
          }
          siteCount={spvsCount}
        />
      </TabLink>
      <ShareLinkWithUserContainer $active={true}>
        <ShareLinkWithUser
          shareAttributes={shareAttributes}
          button={true}
          orgType={orgType}
        />
      </ShareLinkWithUserContainer>
    </TabLinks>
  );
};

const ShareLinkWithUserContainer = styled.div<{ $active: boolean }>`
  margin-left: auto;
  display: ${(props) => (props.$active ? "block" : "none")};
`;
